export const PAGE_TYPE = {
  HOMEPAGE: 'homepage',
  SUBLANDING: 'sub-landing',
  WOOCOMMERCE: 'woocommerce',
  SHOPIFY: 'shopify',
  API: 'api',
};

// tier 1, all prices are in cents
export const PRICING = {
  mug: {
    base: 350,
    premium: 450,
    competitor: {
      base: 800,
      premium: 450,
    },
  },
  case: {
    base: 500,
    competitor: {
      base: 1225,
    },
  },
  dtg: {
    base: 400,
    premium: 600,
    competitor: {
      base: 1400,
      premium: 1500,
    },
  },
  screenprint: {
    quantity: 24,
    screen: 1500,
    pms: 500,
    base: 210,
    premium: 265,
  },
  poster: {
    base: 100,
    '17': 85,
    '24': 120,
    competitor: {
      '17': 800,
      '24': 1200,
    },
  },
};

export const TESTIMONIAL = {
  "ambivalent-moxy": {
    "name": "Mr. Moxy",
    "company": "Ambivalent Moxy",
    "image": "images/ambivalent-moxy.png",
    "text": '"Once you set up a design and choose the garment, the funneling and set up over to Shopify is quite fast."',
  },
  "gearzilla": {
    "name": "Albert Arouh",
    "company": "Gearzilla",
    "image": "images/gearzilla.png",
    "text": '"Scalable Press Rocks!!! Their prices continue to be the lowest of any provider I have found and they combine that with some of the best customer service available."',
  },
  "ryan-conkright": {
    "name": "Ryan Conkright",
    "company": "",
    "image": "images/ryan-conkright.png",
    "text": '"Great quality, great customer service!",'
  },
  "power-rocket": {
    "name": "Brittany Cline",
    "company": "Power Rocket",
    "image": "images/power-rocket.png",
    "text": '"Scalable Press has been such a valuable partner while starting my own online t-shirt shop. Their dedication to quality is amazing, and they don\'t send the product until it\'s perfect! I look forward to using their services for years to come!"',
  },
  "sean-burns": {
    "name": "Sean Burns",
    "company": "",
    "image": "images/sean-burns.png",
    "text": '"Scalable Press is a committed partner and a key to our continued growth. The customer service is second to none."',
  },
  "tim-shields": {
    "name": "Tim Shields",
    "company": "",
    "image": "images/tim-shields.png",
    "text": '"The support from my account rep has been outstanding. Print times are fast and quality is high. My customers love their prints."',
  },
  "coloristees": {
    "name": "George Harris",
    "company": "Coloristees",
    "image": "images/coloristees.png",
    "text": '"Coloristees.com is so lucky to have Scalable Press on our team! Every product we receive is well-made and looks great. We always receive our orders from Scalable Press on time so that our customers get their orders on time, too!"',
  },
};

export const VALID_EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;



// WEBPACK FOOTER //
// ./app/util/constants.js